/* eslint-disable react/jsx-boolean-value */
import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
// components
import ReactPlayer from 'react-player'
import { MotionContainer, TextAnimate, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  padding: theme.spacing(0, 0),
  [theme.breakpoints.up('md')]: {
    padding: 0,
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    position: 'absolute',
    bottom: theme.spacing(10),
  },
}));

// ----------------------------------------------------------------------

export default function VideoV1({block}) {
  return (
    <RootStyle>
      <ReactPlayer url={block.backgroundImg}
                     playing={true} loop={true}  width='100%' height='100%'
                    />
    </RootStyle>
  );
}
